import React from 'react';
import AdvertisementPaymentCancellationWrapper from 'components/AdvertisementPaymentCancellationWrapper';

export default function AdvertisementPaymentCancellationContainer() {
  return <AdvertisementPaymentCancellationWrapper />;
}
